import { Component, Input, OnDestroy, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalNavService, NavegavelEmModal } from 'src/app/core/services/modal-nav.service';

@Component({
	selector: 'app-modal',
	templateUrl: './modal.page.html',
	styleUrls: ['./modal.page.scss'],
})
export class ModalPage implements OnInit, OnDestroy, NavegavelEmModal {

	@Input('root') root: Type<any>;

	@ViewChild('host', { read: ViewContainerRef, static: true }) host: ViewContainerRef;

	/** Telas por baixo da atual — o que o `<ion-nav>` guardava. */
	private readonly pilha: Type<any>[] = [];

	constructor(private modalNav: ModalNavService) { }

	ngOnInit() {
		// ion-nav [root] substituído por render dinâmico do componente root.
		if (!this.root || !this.host) return;
		this.renderizar(this.root);
		this.modalNav.registrar(this);
	}

	ngOnDestroy() {
		this.modalNav.desregistrar(this);
	}

	/** Empilha uma tela por cima da atual (o `nav.push()` do ion-nav). */
	pushEmModal(component: Type<any>) {
		if (!component || !this.host) return;
		this.pilha.push(this.root);
		this.root = component;
		this.renderizar(component);
	}

	/** Volta para a tela anterior (o `nav.pop()`). Falso se já estava na raiz. */
	popEmModal(): boolean {
		const anterior = this.pilha.pop();
		if (!anterior || !this.host) return false;
		this.root = anterior;
		this.renderizar(anterior);
		return true;
	}

	private renderizar(component: Type<any>) {
		this.host.clear();
		const ref = this.host.createComponent(component);
		// O <ion-nav> dava ao root a classe `.ion-page` (flex column + space-between), de que
		// os templates legados dependem para centralizar (`margin:auto`) e distribuir os blocos
		// pela altura. `.mp-page` é o primitivo equivalente — ver mp-modal-page-layout.spec.ts.
		(ref.location.nativeElement as HTMLElement).classList.add('mp-page');
	}

}
